import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

export const useNetworkStatus = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const previousOnlineStatus = useRef(navigator.onLine);
  const navigate = useNavigate();

  useEffect(() => {
    const handleOnline = () => {
      previousOnlineStatus.current = true;
      setIsOnline(true);
    };

    const handleOffline = () => {
      if (previousOnlineStatus.current) {
        if (window.location.pathname !== '/jobsite-management') {
          navigate('/jobsite-management');
        }
      }
      previousOnlineStatus.current = false;
      setIsOnline(false);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [navigate]);

  return { isOnline };
};